import React from 'react';
import { Link, graphql } from 'gatsby';
import Layout from '../components/layout';
import Seo from '../components/seo';

const Blog = ({
  data: {
    allContentfulBlogPost: { edges: allPosts = [] },
  },
}) => (
  <Layout>
    <div style={{ overflow: 'hidden' }}>
      <Seo title="Blog listing" />

      <section className="blogHero position-relative">
        <div className="svg-path svg-path-2 hidden-mobile">
          <svg width="846" height="316" viewBox="0 0 846 316" fill="none">
            <linearGradient
              id="a"
              x1="460.212"
              x2="395.998"
              y1="181.109"
              y2="-77.772"
              gradientTransform="matrix(1 0 0 -1 0 279.002)"
              gradientUnits="userSpaceOnUse">
              <stop offset="0" stopColor="#ffe8f6" />
              <stop offset="1" stopColor="#e6e5ff" />
            </linearGradient>
            <path
              fill="none"
              stroke="url(#a)"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="91"
              d="M45.5 233.8C234.4-56.9 386.1 52 456.2 145.8c10.8 14.5 23.2 27.8 37.1 39.5 57.9 48.9 118.7 112 308.1 73.3"
              opacity=".398"
            />
          </svg>
        </div>
        <div className="svg-path">
          <svg
            width="708"
            height="462"
            viewBox="0 0 708 462"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              stroke="url(#paint0_linear)"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="91"
              d="M-178 49.393C13.752 4.707 66.32 416.145 294.288 416.145c150.962 0 244.328-113.165 367.677-185.418"
              opacity=".398"
            />
            <defs>
              <linearGradient
                id="paint0_linear"
                x1="315.415"
                x2="81.875"
                y1="149.715"
                y2="482.449"
                gradientUnits="userSpaceOnUse">
                <stop stopColor="#FFE8F6" />
                <stop offset="1" stopColor="#E6E5FF" />
              </linearGradient>
            </defs>
          </svg>
        </div>
        <span className="big-gradient-circle small-gradient green-gradient" />
        <span className="big-gradient-circle small-gradient green-gradient gradient-2" />
        <div className="small-container">
          <h3 className="text-center-mob">From the cliphire lab </h3>
          <div className="hero-main">
            <div className="flex-row no-margin align-items-center">
              <div className="col col-6">
                <div className="hero-image-box">
                  <img
                    src={allPosts[0]?.node?.featuredImage?.fluid?.src}
                    alt=""
                    className="hero-image"
                  />
                  <img
                    src="/img/latest-blog-tilted.svg"
                    alt=""
                    className="latest-blog-tilted"
                  />
                </div>
              </div>
              <div className="col col-6">
                <div className="hero-contents">
                  <div className="blog-author flex-row no-margin align-items-center">
                    <img
                      src={allPosts[0]?.node?.author?.image?.fluid?.src}
                      alt=""
                      className="author-image"
                      style={{
                        width: 25,
                        height: 25,
                        borderRadius: '50%',
                        objectFit: 'cover',
                      }}
                    />
                    <h5>
                      {allPosts[0]?.node?.author?.name},{' '}
                      <span>{allPosts[0]?.node?.publishedDate}</span>
                    </h5>
                  </div>
                  <h3>{allPosts[0]?.node?.title}</h3>
                  <p>{allPosts[0]?.node?.excerpt?.excerpt}</p>
                  <Link
                    className="button"
                    to={`/blog/${allPosts[0]?.node?.slug}`}>
                    Read More
                    <img src="/img/arrow-small.svg" alt="" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="blogList position-relative">
        <span className="big-gradient-circle small-gradient red-gradient" />
        <span className="big-gradient-circle" />
        <div className="small-container">
          <h4 className="blog-list-heading text-center-mob">
            Our thoughts and observations on business, partners, nutrients,
            productivity, <span>Science, &amp; more.</span>
          </h4>
          <div className="flex-row">
            {allPosts.map(({ node }, i) => (
              <React.Fragment key={i}>
                {i === 0 ? null : (
                  <div className="col col-6">
                    <Link to={`/blog/${node?.slug}`}>
                      <div className="blog-container">
                        <div className="blog-image-wrapper">
                          <img
                            src={node?.featuredImage?.fluid?.src}
                            alt=""
                            className="blog-image"
                          />
                        </div>
                        <div className="blog-author flex-row no-margin align-items-center">
                          <img
                            src={node?.author?.image?.fluid?.src}
                            alt=""
                            className="author-image"
                            style={{
                              width: 25,
                              height: 25,
                              borderRadius: '50%',
                              objectFit: 'cover',
                            }}
                          />
                          <h5>
                            {node?.author?.name},{' '}
                            <span>{node?.publishedDate}</span>
                          </h5>
                        </div>
                        <h4>{node?.title}</h4>
                        <p>{node?.excerpt?.excerpt}</p>
                      </div>
                    </Link>
                  </div>
                )}
              </React.Fragment>
            ))}
          </div>
          {/*<button className="button">Load more blogs</button>*/}
        </div>
      </section>
    </div>
  </Layout>
);

export default Blog;

export const pageQuery = graphql`
  query BlogIndexQuery {
    allContentfulBlogPost(sort: { fields: publishedDate, order: DESC }) {
      edges {
        node {
          title
          id
          slug
          publishedDate(formatString: "MMMM Do, YYYY")
          excerpt {
            excerpt
          }
          featuredImage {
            fluid {
              src
            }
          }
          author {
            name
            image {
              fluid {
                src
              }
            }
          }
        }
      }
    }
  }
`;
